import { render, staticRenderFns } from "./communities.vue?vue&type=template&id=4257761a&scoped=true"
import script from "./communities.vue?vue&type=script&lang=js"
export * from "./communities.vue?vue&type=script&lang=js"
import style0 from "./communities.vue?vue&type=style&index=0&id=4257761a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4257761a",
  null
  
)

export default component.exports